import React from 'react'
// import lokeshj from '../../public/lokesh2'
// import pbf1 from '../../public/lcv.pdf';

export const Nav = () => {
  const handleRef = (param) => window.scrollTo(0, param);
  return (
    <>
      <div className="imgmain"><img src={process.env.PUBLIC_URL + "/lokesh2.jpg"} alt="error" /></div>
      <div id="menu">
        <div id="menu-bar">
          <div id="bar1" className="bar"></div>
          <div id="bar2" className="bar"></div>
          <div id="bar3" className="bar"></div>
        </div>
        <nav className="nav" id="nav">
          <ul>
            <li onClick={() => handleRef(900)}><b>01.</b>ABOUT</li>
            <li onClick={() => handleRef(1350)}><b>02.</b>WORK</li>
            <li onClick={() => handleRef(3600)}><b>03.</b>STUDIES</li>
            <li onClick={() => handleRef(5000)}><b>04.</b>CONTACT</li>
            <button className="button"><a href={process.env.PUBLIC_URL + "/lcv.pdf"}>Resume</a></button>
          </ul>
        </nav>
      </div>
      <div className="menu-bg" id="menu-bg"></div>
    </>
  )
}
